import { DateInput } from 'components';
import { i18n } from '@app/i18n';
import moment from 'moment-timezone';
import { Participant } from '@app/api';
/*
 * If I can delete this file
 * No specific code for the client left
 */

export const TandemzSpecialConf = {
  orgId: '12d88429-22a1-444a-bc1c-12db851af86e',
  specialFields: [
    {
      name: '__tandemzLastInteraction',
      participantLabel: 'Dernière interaction',
      clientLabel: 'Dernière interaction',
      formComponent: DateInput,
      accessor: (p: any) =>
        p.__tandemzLastInteraction
          ? moment(p.__tandemzLastInteraction).format('L')
          : null,
    },
    {
      name: 'studySubjectPreferences',
      participantLabel: i18n.t('participants.display.studySubjectPreferences'),
      clientLabel: i18n.t('participants.display.studySubjectPreferences'),
      formComponent: 'div',
      accessor: (p: Participant) =>
        p.studySubjectPreferences && p.studySubjectPreferences.join(', '),
    },
    {
      name: 'studyTypePreferences',
      participantLabel: i18n.t('participants.display.studyTypePreferences'),
      clientLabel: i18n.t('participants.display.studyTypePreferences'),
      formComponent: 'div',
      accessor: (p: Participant) =>
        p.studyTypePreferences && p.studyTypePreferences.join(', '),
    },
  ],
};
